import { render, staticRenderFns } from "./MoreGigsSection.htm?vue&type=template&id=3c3eab2c&scoped=true&"
import script from "./MoreGigsSection.ts?vue&type=script&lang=js&"
export * from "./MoreGigsSection.ts?vue&type=script&lang=js&"
import style0 from "./MoreGigsSection.scss?vue&type=style&index=0&id=3c3eab2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3eab2c",
  null
  
)

export default component.exports